module.exports = __webpack_public_path__ + "static/media/news-bg-ma.7ee6d638.jpg";